

<div #messagecontainer class="rest-of simple-scroll">
  <a *ngIf="currentChatConversation?.lowestSequenceNumber<currentChatConversation?.lowestSequenceNumberOfCurrentMessageRange" (click)="loadOlderMessages()" class="load-msg">Load older messages</a>
  <!--  <a *ngIf="topIndex>0" (click)="loadOlderMessages()" class="load-msg">Load older messages</a>-->
  <div *ngFor="let messageObj of messages" class="message-container flex flex-row justify-start items-start"
       (mouseover)="messageObj.hover=true" (mouseleave)="messageObj.hover=false">
    <div *ngIf="messageObj.isSystemMessage && !messageObj.callInvitationId" class="system-msg message-box flex flex-row justify-center items-start">
      <span [innerHtml]="messageObj.message" [id]="'quick-'+messageObj.sequence"></span>
    </div>
    <div *ngIf="messageObj.isDeleted" class="deleted-text message-box me flex flex-row justify-start items-start">
      <i class="far fa-exclamation-circle"></i><span [id]="'quick-'+messageObj.sequence">This message has been removed</span>
    </div>

    <!-- A call row (D-18): the card alone, no bubble, in the caller's column (ITP-E-189-13) — as in the conversation. -->
    <div *ngIf="!messageObj.isDeleted && messageObj.callInvitationId" class="call-row" [ngClass]="messageObj.isMine ? 'mine' : 'theirs'">
      <div class="call-row-body">
        <app-call-card [id]="'quick-'+messageObj.sequence" [message]="messageObj" [conversationId]="currentChatConversation?.id"
                       [isGroup]="!!currentChatConversation?.isGroupConversation"
                       [title]="currentChatConversation?.title"></app-call-card>
      </div>
      <div class="call-row-meta flex flex-row justify-end items-center">
        <button mat-icon-button [matMenuTriggerFor]="callMenu" *ngIf="!hasLeft" class="reply-menu call-row-menu" aria-label="Message options"
                particleAnalytics analyticsCategory="conversation" analyticsAction="more-btn">
          <i class="fal fa-ellipsis-h"></i>
        </button>
        <span class="timing">{{messageObj.createdDate | timeAgo}}</span>
        <div *ngIf="messageObj.isMine">
          <i *ngIf="messageObj.readStatus === 'AllRead'" class="fal fa-check-double all-seen"></i>
          <i *ngIf="!messageObj.readStatus || messageObj.readStatus === 'Unread'" class="fal fa-check not-seen"></i>
          <i *ngIf="messageObj.readStatus === 'SomeRead'" class="fal fa-check partically-seen"></i>
        </div>
        <mat-menu #callMenu="matMenu" [overlapTrigger]="false">
          <button mat-menu-item (click)="replyMessage(messageObj)">
            <span>Reply</span>
          </button>
          <button mat-menu-item (click)="removeMessage(messageObj, false)">
            <span>Delete for Me</span>
          </button>
          <button mat-menu-item *ngIf="messageObj.isMine" (click)="removeMessage(messageObj, true)">
            <span>Delete for Everyone</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div *ngIf="!messageObj.isDeleted && !messageObj.isSystemMessage && !messageObj.callInvitationId" [ngClass]="messageObj.isMine ? 'message-box me' : 'message-box others'">
      <!-- ITP-E-193-02: a reply to a call row quotes the call as a small, read-only card, no Join.
           ITP-E-193-03: every quote goes to the message it answers (goToRepliedMessage). -->
      <div class="flex flex-row" *ngIf="messageObj?.replyTo?.callInvitationId">
        <div class="w-p-100 flex flex-col">
          <div class="reply-text reply-jump reply-call m-t-10 flex flex-col"
               role="button" tabindex="0" aria-label="Go to the message"
               (click)="goToRepliedMessage(messageObj.replyTo, $event)"
               (keydown.enter)="goToRepliedMessage(messageObj.replyTo, $event)"
               (keydown.space)="goToRepliedMessage(messageObj.replyTo, $event)"
               [ngClass]="messageObj.replyTo.createdBy?.email === currentUser.email ? 'me' : 'others'">
            <span *ngIf="messageObj.replyTo.createdBy?.email !== currentUser.email"
                  class="sender">{{messageObj.replyTo.createdBy?.firstName}} {{messageObj.replyTo.createdBy?.lastName}}</span>
            <app-call-card [compact]="true" [message]="messageObj.replyTo"
                           [conversationId]="currentChatConversation?.id"></app-call-card>
          </div>
        </div>
      </div>
      <div class="flex flex-row" *ngIf="messageObj?.replyTo?.message && !messageObj?.replyTo?.callInvitationId">
        <div *ngIf="messageObj?.replyTo?.createdBy?.email === currentUser.email" class="w-p-100">
          <div class="reply-text reply-jump me m-t-10"
               role="button" tabindex="0" aria-label="Go to the message"
               (click)="goToRepliedMessage(messageObj.replyTo, $event)"
               (keydown.enter)="goToRepliedMessage(messageObj.replyTo, $event)"
               (keydown.space)="goToRepliedMessage(messageObj.replyTo, $event)"
               [innerHtml]="messageObj.replyTo.message">
          </div>
        </div>
        <div *ngIf="messageObj?.replyTo?.createdBy?.email !== currentUser.email" class="w-p-100 flex flex-col" >
          <div class="reply-text reply-jump others m-t-10 flex flex-col"
               role="button" tabindex="0" aria-label="Go to the message"
               (click)="goToRepliedMessage(messageObj.replyTo, $event)"
               (keydown.enter)="goToRepliedMessage(messageObj.replyTo, $event)"
               (keydown.space)="goToRepliedMessage(messageObj.replyTo, $event)">
            <span class="sender">{{messageObj?.replyTo?.createdBy?.firstName}} {{messageObj?.replyTo?.createdBy?.lastName}}</span>
            <span class="m-t-4 message"
                  [innerHtml]="messageObj.replyTo.message">
          </span>
          </div>
        </div>
      </div>
      <div *ngIf="messageObj?.attachment" class="w-p-100 flex flex-row">
        <span class="reply-text me m-t-10" *ngIf="messageObj?.createdBy?.email === currentUser.email" [innerHtml]="messageObj.attachment">
        </span>
        <span class="reply-text others m-t-10" *ngIf="messageObj?.createdBy?.email !== currentUser.email" [innerHtml]="messageObj.attachment">
        </span>
      </div>
      <div class="flex flex-col">
        <span [ngClass]="messageObj.isMine ? 'hideBlock' : 'showBlock sender'">{{messageObj.createdBy?.firstName}} {{messageObj.createdBy?.lastName}}</span>
        <span [innerHtml]="messageObj.message" [id]="'quick-'+messageObj.sequence"></span>
        <span *ngIf="messageObj.isEdited" class="edited">(Edited)</span>
        <span *ngIf="messageObj.data && messageObj.data[0]">
                <button (click)="onRevertToOldValue(messageObj.data[0])" class="revert-value" disabled="true">
                  Revert
                </button>
              </span>

        <div class="chat-spinner" *ngIf="messageObj.isTemporary">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>


        <button mat-icon-button [matMenuTriggerFor]="msgMenu" *ngIf="!hasLeft" [style.visibility]="messageObj.isTemporary ? 'hidden': 'visible'"
                class="reply-menu"
                particleAnalytics
                analyticsCategory="conversation"
                analyticsAction="more-btn">
          <i class="fal fa-ellipsis-h"></i>
        </button>
      </div>


      <div class="flex flex-row justify-end items-center">
        <span class="timing">
          {{messageObj.createdDate | timeAgo}}
        </span>
        <div *ngIf="messageObj.isMine && !messageObj.isTemporary">
          <i *ngIf="messageObj.readStatus === 'AllRead'" class="fal fa-check-double all-seen "></i>
          <i *ngIf="!messageObj.readStatus || messageObj.readStatus === 'Unread' || messageObj.readStatus === 'Delivered'" class="fal fa-check not-seen"></i>
          <i *ngIf="messageObj.readStatus === 'SomeRead'" class="fal fa-check partically-seen"></i>
        </div>

        <mat-menu #msgMenu="matMenu" [overlapTrigger]="false">
          <button mat-menu-item (click)="replyMessage(messageObj)">
            <span>Reply</span>
          </button>
          <button mat-menu-item *ngIf="messageObj.isMine && !messageObj.isInitialMessage && !messageObj.data && !messageObj.callInvitationId && !messageObj.card?.kind" (click)="editMessage(messageObj)">
            <span>Edit</span>
          </button>
          <button mat-menu-item *ngIf="!messageObj.isInitialMessage && !messageObj.data" (click)="removeMessage(messageObj, false)">
            <span>Delete for Me</span>
          </button>
          <button mat-menu-item *ngIf="messageObj.isMine && !messageObj.isInitialMessage && !messageObj.data" (click)="removeMessage(messageObj, true)">
            <span>Delete for Everyone</span>
          </button>
        </mat-menu>
      </div>

    </div>

  </div>
  <!--<a *ngIf="lastIndex<messages?.length" (click)="loadNewerMessages()" class="load-msg">Load newer messages</a>-->
</div>

<!--<div class="chat-footer">
  <textarea type="text" (keyup.enter)="sendMessage()" (click)="markReadIfNeeded()" [(ngModel)]="chatText"
            [placeholder]="currentChatConversation.waitingMessage?currentChatConversation.waitingMessage:'Enter message...'"></textarea>
  <div class="chat-footer-btn-container" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button
              particleAnalytics
              analyticsCategory="conversation"
              analyticsAction="attach-btn">
        <i class="fal fa-paperclip"></i>
      </button>
      <button mat-icon-button
              particleAnalytics
              analyticsCategory="conversation"
              analyticsAction="smile-btn">
        <i class="fal fa-smile"></i>
      </button>
      <div>
        <button mat-icon-button [matMenuTriggerFor]="chatFooterMenu"
                class="user-button"
                particleAnalytics
                analyticsCategory="conversation"
                analyticsAction="user-btn">
          <i class="fal fa-ellipsis-h"></i>
        </button>

        <mat-menu #chatFooterMenu="matMenu" [overlapTrigger]="false">

          <button mat-menu-item>

            <span>Sample Text 01</span>
          </button>

          <button mat-menu-item class="">
            <span>Sample Text 02</span>
          </button>


        </mat-menu>
      </div>
    </div>
    <button mat-icon-button (click)="sendMessage()"
            particleAnalytics
            analyticsCategory="conversation"
            analyticsAction="send-message-btn"><i class="fal fa-paper-plane"></i></button>
  </div>


</div>-->
<particle-chat-editor
  [editorId]="'quickviewchat-textarea'"
  [text]="chatText"
  [allContacts]="allContacts"
  [hashTagList]="hashTagList"
  [hideDac6CardLink]="true"
  [replyToMessage]="replyToMessage"
  [focusEditor$]="focusEditorOnChatEditor$"
  [placeholder]="currentChatConversation.waitingMessage?currentChatConversation.waitingMessage:'Enter message...'"
  (cancelReplyEvent)="onCancelReply($event)"
  (outputChatEditorEvent)="sendMessage($event)"
  (showDAC6Card)="onShowDac6Card($event)"
>
</particle-chat-editor>
